import type * as React from 'react'

// SectionEyebrow -- the canonical small-caps tracked uppercase label
// used above every section H2 on the marketing site. Replaces the
// older mix of <Badge variant="secondary"> and inline <p> styles
// per user feedback ("plz be consistent.. I like the caps style
// simple", May 2026).
//
// Visual: 11px bold uppercase, letter-spacing 0.22em, primary brand
// colour. No background fill, no pill chrome -- just a small label.

export function SectionEyebrow({
  children,
  className = '',
  tone = 'primary',
}: {
  children: React.ReactNode
  className?: string
  /** `primary` = brand blue. `muted` = soft grey for surfaces where
   *  the primary clash is too loud. */
  tone?: 'primary' | 'muted'
}) {
  const toneClass = tone === 'muted' ? 'text-foreground/65' : 'text-primary'
  return (
    <p className={`text-[11px] font-bold uppercase tracking-[0.22em] ${toneClass} ${className}`}>
      {children}
    </p>
  )
}
